module.exports = __webpack_public_path__ + "static/service_en_bg-b05c1d2fc3131c5b6b68865dcd1e2ccf.png";